(function ($) {
	var box = $('.platform-wrapper .box'),
		icon = $('.platform-wrapper .box .icon'),
		cake = $('.platform-cake .cake'),
		target = $('.platform-cake .target');

	box.hover(desktopShow, desktopHide);
	function desktopShow() {
		// @ts-ignore-next
		var el = $(this),
			dataId = el.data('id'),
			currentIcon = el.find('.icon');
		// @ts-ignore-next
		activeCake = $('.cake.is-active');

		box.removeClass('is-active');
		icon.removeClass('is-active');
		currentIcon.addClass('is-active');
		el.addClass('is-active');
		// @ts-ignore-next
		activeCake.removeClass('is-active');
		$('.platform-cake .cake[data-id="' + dataId + '"]').addClass(
			'is-active'
		);
	}
	function desktopHide() {
		// @ts-ignore-next
		var el = $(this),
			dataId = el.data('id'),
			currentIcon = el.find('.icon');
		// @ts-ignore-next
		activeCake = $('.cake.is-active');

		box.removeClass('is-active');
		icon.removeClass('is-active');
		currentIcon.addClass('is-active');
		el.addClass('is-active');
		// @ts-ignore-next
		activeCake.removeClass('is-active');
		$('.platform-cake .cake[data-id="' + dataId + '"]').addClass(
			'is-active'
		);
	}

	target.hover(desktopCakeShow, desktopCakeHide);
	function desktopCakeShow() {
		// @ts-ignore-next
		var el = $(this),
			dataId = el.data('id');

		cake.removeClass('is-active');
		box.removeClass('is-active');
		icon.removeClass('is-active');
		$('.platform-cake .cake[data-id="' + dataId + '"]').addClass(
			'is-active'
		);
		$('.platform-wrapper .box[data-id="' + dataId + '"]').addClass(
			'is-active'
		);
	}
	function desktopCakeHide() {
		// @ts-ignore-next
		var el = $(this),
			dataId = el.data('id');

		cake.removeClass('is-active');
		box.removeClass('is-active');
		icon.removeClass('is-active');
		$('.platform-cake .cake[data-id="' + dataId + '"]').addClass(
			'is-active'
		);
		$('.platform-wrapper .box[data-id="' + dataId + '"]').addClass(
			'is-active'
		);
	}

	// slider on mobile
	var sliderPlatform = $('.slider-mobile');
	// @ts-ignore-next
	slider_options = {
		slidesToShow: 1,
		slidesToScroll: 1,
		mobileFirst: true,
		dots: true,
		// @ts-ignore-next
		customPaging: function (slider, i) {
			return '<span class="slider-dot"></span>';
		},
		arrows: false,
		responsive: [
			{
				breakpoint: 1279,
				settings: 'unslick',
			},
		],
	};

	// @ts-ignore-next
	slick_on_mobile(sliderPlatform, slider_options);

	// @ts-ignore-next
	function slick_on_mobile(slider, settings) {
		$(window).on('load resize orientationchange', function () {
			// @ts-ignore-next
			if ($(window).width() > 1279) {
				if (slider.hasClass('slick-initialized')) {
					slider.slick('unslick');
				}
				return;
			}
			if (!slider.hasClass('slick-initialized')) {
				return slider.slick(settings);
			}
		});
	}
})(jQuery);
